/**
 * SOURCE DE VÉRITÉ de la version applicative du CMS (front).
 *
 * Pourquoi un fichier dédié et pas package.json ? CRA (ModuleScopePlugin) interdit
 * d'importer package.json depuis un composant (il est hors de src/). Ce module est
 * donc LA référence lue par l'UI (pied de la sidebar).
 *
 * CONVENTION DE VERSIONING (voir VERSIONING.md) :
 *  - Semver MAJOR.MINOR.PATCH.
 *      MAJOR : refonte / rupture (ex. la console V2).
 *      MINOR : nouvelle fonctionnalité rétrocompatible.
 *      PATCH : correctif / ajustement UI.
 *  - À CHAQUE commit significatif : incrémenter APP_VERSION ici, mettre à jour
 *    APP_BUILD_DATE, et préfixer le sujet du commit par [vX.Y.Z].
 *  - Idéalement, refléter le même numéro dans package.json ("version").
 */
export const APP_VERSION = '2.4.4';

// Date de la version courante (AAAA-MM-JJ). À mettre à jour lors d'un bump.
export const APP_BUILD_DATE = '2026-07-24';

// Chaîne prête à afficher / logger.
export const APP_VERSION_LABEL = `v${APP_VERSION}`;

export default APP_VERSION;
